module.exports = "pegasus/assets/blocks/column-lp17-basic.png";